import * as Sentry from '@sentry/browser'
import { put, takeLatest } from 'redux-saga/effects'

import { request } from '../../../1stlog-ui/src/utils'
import { receive } from './actions'
import { REQUEST } from './constants'

const saga = 'containers/AddressSearchInput/saga'

export default function* root() {
  try {
    yield takeLatest(REQUEST, handleRequest)
  } catch (error) {
    console.error(error)
    Sentry.captureMessage(error, { extra: { error, saga } })
  }
}

export function* handleRequest({
  payload,
  payload: { currentAddress, query, field, search },
}) {
  try {
    let { data } = yield request({
      method: 'post',
      url: `/api/addressbook/autocomplete`,
      data: {
        [field]: query,
      },
    })
    yield put(receive({ result: data }))
  } catch (error) {
    console.error(error)
    Sentry.captureMessage(error, {
      extra: { saga, payload },
    })
    yield put(receive({ error }))
  }
}
